import { Component, OnInit, OnDestroy, Input, HostListener, ElementRef, Output, EventEmitter, PLATFORM_ID, Inject } from '@angular/core';
import { CommonModule, isPlatformBrowser } from "@angular/common";
import { BlogList } from '../../../_models/blogs/blog.model';
import { MenuStateService } from '../../../_services/app/menu-state.service';
import { Router } from '@angular/router';
import { BlogService } from '../../../_services/api/blog.service';
import { NotificationService } from '../../../_services/app/notification.service';

@Component({
  selector: 'app-admin-blog-card',
  imports: [CommonModule],
  templateUrl: './admin-blog-card.html',
  styleUrl: './admin-blog-card.scss',
})
export class AdminBlogCard implements OnInit, OnDestroy {
  @Input() blog!: BlogList;
  @Output() blogUpdated = new EventEmitter<void>();
  @Output() blogDeleted = new EventEmitter<void>();
  
  menuOpen = false;
  showDeleteModal = false;
  isUpdatingVisibility = false;

  constructor(
    private menuStateService: MenuStateService,
    private notification: NotificationService,
    private elementRef: ElementRef,
    private router: Router,
    private blogService: BlogService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    this.menuStateService.activeMenu$.subscribe(activeId => {
      this.menuOpen = activeId === this.blog.id;
    });
    if (isPlatformBrowser(this.platformId)) {
        document.addEventListener('click', this.closeMenu.bind(this));
    }
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
        document.removeEventListener('click', this.closeMenu.bind(this));
    }
  }

  toggleMenu(event: MouseEvent) {
    event.stopPropagation();
    if (this.menuOpen) {
      this.menuStateService.setActiveMenu(null);
    } else {
      this.menuStateService.setActiveMenu(this.blog.id);
    }
  }

  @HostListener('document:click', ['$event'])
  closeMenu(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.menuOpen = false;
    }
    if (this.menuOpen) {
      this.menuStateService.setActiveMenu(null);
    }
  }

  setDefaultImage(event: any): void {
    event.target.src = './assets/images/blog-default.png';
  }

  editBlog(): void {
    this.menuOpen = false;
    this.router.navigate(['/admin/articles/edit', this.blog.id]);
  }

  toggleVisibility(): void {
    if (this.isUpdatingVisibility) return;
    
    this.isUpdatingVisibility = true;
    this.menuStateService.setActiveMenu(null);
    this.menuOpen = false;
    
    if (this.blog.visible) {
      this.blogService.makeBlogHidden(this.blog.id).subscribe({
        next: () => {
          this.blog.visible = false;
          this.blogUpdated.emit();
          this.isUpdatingVisibility = false;
          this.notification.showSuccess("L’article a été retiré du public et n’est accessible qu’en privé.");
        },
        error: (error) => {
          console.error('Error making blog hidden:', error);
          this.isUpdatingVisibility = false;
          this.notification.showError('Erreur lors de la modification de la visibilité');
        }
      });
    } else {
      this.blogService.makeBlogVisible(this.blog.id).subscribe({
        next: () => {
          this.blog.visible = true;
          this.blogUpdated.emit();
          this.isUpdatingVisibility = false;
          this.notification.showSuccess("L’article a été mis en ligne et est désormais accessible au public.");
        },
        error: (error) => {
          console.error('Error making blog visible:', error);
          this.isUpdatingVisibility = false;
          this.notification.showError('Erreur lors de la modification de la visibilité');
        }
      });
    }
  }

  confirmDelete(): void {
    this.menuOpen = false;
    this.showDeleteModal = true;
  }

  closeDeleteModal(): void {
    this.showDeleteModal = false;
  }

  deleteBlog(): void {
    this.blogService.deleteBlog(this.blog.id).subscribe({
      next: () => {
        this.showDeleteModal = false;
        this.blogDeleted.emit();
      },
      error: (error) => {
        console.error('Error deleting blog:', error);
        alert('Erreur lors de la suppression de l\'article');
        this.showDeleteModal = false;
      }
    });
  }
}